export { DSButtonV3, DSButtonV3WithSchema } from './DSButtonV3.js';
export type { DSButtonV3T } from './react-desc-prop-types.js';
// menu-button overloads the button, so we need to export the button's prop types to be used in the menu-button prop types definition
export { DSButtonV3PropTypes, DSButtonV3PropTypesSchema } from './react-desc-prop-types.js';
